// extracted by mini-css-extract-plugin
export var icon360 = "_360-module--icon360--1scA5";
export var icon360Primary = "_360-module--icon360--primary--2Dr2y";